import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { request } from '../../../api';
import cancelPieceForm from '../cancel_piece_form';

const VtrgTextForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    body: data && data.body ? data.body : '',
    inverted: data && data.inverted ? data.inverted : 0,
    back_color: data && data.back_color,
    text_color: data && data.text_color
  });

  const [type, setType] = useState(values.inverted);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }

    // TODO костыль
    //console.log(e.action);
    //console.log(values);
    //console.log(localData);
    Object.keys(localData)
      .filter(key => key in values)
      .forEach(key => (localData[key] = values[key]));
    //

    axios
      .post(
        `${request}/vitrage/pieces/${slot ? slot : 'new'}`, 
        localData
      )
      .then(response => {
        if (response.statusText === 'OK') {
          setSuccessMsg('Изменения успешно внесены');
          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(localData);
          }
        } else {
          setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
        }
      })
      .catch(error => {
        console.log(error);
        setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg('Произошла ошибка');
  };

  return (
    <div className="vtrg-edit-body">
      <h3>Текстовый блок:</h3>
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="formtastic vitrage_pieces_vtrg_text"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : 'new'}}`}
        acceptCharset="UTF-8"
        dataRemote="true"
        method="post"
      >
        <fieldset className="inputs">
          <select
            defaultValue={data && data.inverted ? 1 : 0}
            {...register('inverted', { value: values.inverted })}
            onChange={e => {
              setValues(values => {
                  values.inverted = parseInt(e.target.value);
                  return values;
              });
              setType(parseInt(e.target.value))
            }}
          >
            <option value="0">Обычный</option>
            <option value="1">Инвертированный</option>
            <option value="2">Свой выбор</option>
          </select>
        </fieldset>
        {(type && type === 2) ? <>
          <fieldset className="inputs">
            <label>Цвет фона</label>
            <input
              type="color"
              name="back_color"
              defaultValue={ values && values.back_color ? values.back_color : '' }
              placeholder="например: #FFF"
              {...register('back_color', { value: values.back_color })}
              onChange={e => {
                setValues(values => {
                  values.back_color = e.target.value;
                  return values;
                });
              }}
            />
          </fieldset>
          <fieldset className="inputs">
            <label>Цвет текста</label>
            <input
              type="color"
              name="text_color"
              defaultValue={ values && values.text_color ? values.text_color : '' }
              placeholder="например: #FFF"
              {...register('text_color', { value: values.text_color })}
              onChange={e => {
                setValues(values => {
                  values.text_color = e.target.value;
                  return values;
                });
              }}
            />
          </fieldset>
        </> : <></> }

        <fieldset className="inputs">
          <Editor
            id="vitrage_pieces_vtrg_text_body"
            apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
            cloudChannel="dev"
            init={{
              plugins: 'paste',
              contextmenu: "image",

              paste_preprocess: function(_, args) {
                args.content = args.content.replace(/&amp;/g, '&');
              }
            }}
            {...register('body', { value: values.body })}
            initialValue={data && data.body}
            onEditorChange={newText => {
              setValues(values => {
                values.body = newText;
                return values;
              });
            }}
          />

          <input
            type="hidden"
            name="kind"
            value={pieceType}
            {...register('kind', { value: pieceType })}
          />
          <input
            type="hidden"
            name="owner_type"
            value={instanceType}
            {...register('owner_type', { value: instanceType })}
          />
          <input
            type="hidden"
            name="owner_id"
            value={instanceId}
            {...register('owner_id', { value: instanceId })}
          />
        </fieldset>

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? 'actions_disable' : 'actions'}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgTextForm;
